import { CustomColumnTypes } from "@/enum/list.enum";

import AiColumn from "@assets/icons/aiColumn.svg?url";
import googleNewsIcon from "@/assets/icons/googleNewsIcon.svg?url";
import departmentIcon from "@/assets/icons/sidebar/site-map.svg?url";
import toolIcon from "@/assets/icons/sidebar/screw-driver-wrench.svg?url";
import linkedinIcon from "@/assets/icons/linkedin.svg?url";
import jobIcon from "@/assets/icons/job.svg?url";

export const getSvgIcons = (type: CustomColumnTypes) => {
	if (type === CustomColumnTypes.AI_PROMPT) {
		return AiColumn;
	}

	if (type === CustomColumnTypes.LEAD_SCORING) {
		return AiColumn;
	}

	if (type === CustomColumnTypes.GOOGLE_NEWS) {
		return googleNewsIcon;
	}

	if (type === CustomColumnTypes.DEPARTMENT_SIZE) {
		return departmentIcon;
	}

	if (type === CustomColumnTypes.TECHNOLOGY) {
		return toolIcon;
	}

	if (type === CustomColumnTypes.LINKEDIN_POST) {
		return linkedinIcon;
	}

	if (type === CustomColumnTypes.JOB_OFFER) {
		return jobIcon;
	}

	return undefined;
};
